import React from 'react';
import ReactModal from 'react-modal';
import { theme } from '../Theme';
import { ReactComponent as Cross } from '@jetshop/ui/svg/Cross.svg';
import { styled } from 'linaria/react';
import { DynamicContentRenderer } from '../ContentEditor/DynamicContentRenderer';
import { sizeGuideComponents } from '../ContentEditor/ContentEditorComponents';
import { useIntl } from '@jetshop/intl';

const ModalWrapper = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
`;

const ModalContainer = styled('div')`
  background-color: white;
  width: 100vw;
  max-width: 60%;
  position: relative;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  pointer-events: all;
  height: 44vw;
  overflow-y: scroll;

  svg.close-icon {
    cursor: pointer;
    padding: 7px;
    border-radius: 50%;
    background: #f7f7f7;
    z-index: 1;
    width: 30px;
    height: 30px;
    color: black;
    position: sticky;
    top: 23px;
    left: 100%;
    margin-right: 23px;
    /* position: absolute;
    top: 23px;
    right: 30px; */

    use,
    g,
    path {
      fill: black;
    }

    ${theme.below.lg} {
      top: 15px;
      right: 15px;
    }
  }

  ${theme.below.lg} {
    width: 100vw !important;
    max-width: 100vw;
    height: 100%;
  }
`;

const Content = styled('div')`
  display: flex;
  /* height: 100%; */
  width: 100%;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
`;

export const Popup = ({ isOpen, setIsOpen, categoryId }) => {
  let catID = categoryId;
  try {
    catID = parseInt(categoryId);
  } catch (error) {
    catID = null;
  }

  const translate = useIntl();
  const somethingWentWrongText = translate('Ops! Something went wrong');
  return (
    <ModalWrapper
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false);
      }}
    >
      <ModalContainer>
        <Cross
          className="close-icon"
          onClick={() => {
            setIsOpen(false);
          }}
        />
        <Content>
          {catID ? (
            <DynamicContentRenderer
              categoryId={catID}
              rendererComponents={sizeGuideComponents}
            />
          ) : (
            <p>{somethingWentWrongText}</p>
          )}
        </Content>
      </ModalContainer>
    </ModalWrapper>
  );
};
